import { Listbox, Transition } from '@headlessui/react';
import { Fragment } from 'react';
import { isSkillup } from '../../../lib/config/project/project';
import { Sort } from '../../../lib/types';
import ChevronDownIcon from '../../icons/ChevronDown';

interface DesktopSortProps {
  sortOptions: Sort[];
  selectedSort: Sort;
  applySort: (sort: Sort) => void;
  isCareers?: boolean;
}

const DesktopSort: React.FC<DesktopSortProps> = ({
  sortOptions,
  selectedSort,
  isCareers,
  applySort,
}) => {
  const buttonClassName = isSkillup
    ? 'flex items-center py-3 '
    : 'w-64 w-full py-2';

  const arrowClassName = isSkillup
    ? 'bg-profileButtons'
    : isCareers
      ? 'pr-4 bg-careerPageHighlight'
      : 'pr-4 bg-primary';

  const textClass = isSkillup
    ? 'text-primary'
    : isCareers
      ? 'text-careerPageHighlight'
      : 'text-primary';


  return (
    <Listbox
      value={selectedSort}
      onChange={applySort}
    >
      <div
        data-testid="desktop_sort"
        className="relative">
        <Listbox.Button
          className={`${buttonClassName} relative pl-6 pr-16 text-left rounded-full shadow-md cursor-pointer w-auto h-[40px] bg-gray3 focus:outline-none focus-visible:ring-2 focus-visible:ring-opacity-75 focus-visible:ring-white focus-visible:ring-offset-orange-300 focus-visible:ring-offset-2 focus-visible:border-indigo-500 sm:text-sm`}
        >
          <span
            className={`${isSkillup ? 'text-base  text-black' : 'text-sm  text-black'
              } block truncate font-base font-bold`}
          >
            {selectedSort?.label}
          </span>
          <span
            className={`${arrowClassName} absolute pl-3 pr-2 rounded-tr-full rounded-br-full inset-y-0 right-0 flex items-center pointer-events-none `}
          >
            <ChevronDownIcon
              className="relative w-5 h-5 stroke-white right-1"
              aria-hidden="true"
            />
          </span>
        </Listbox.Button>
        <Transition
          as={Fragment}
          leave="transition ease-in duration-100"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <Listbox.Options className="absolute z-[12] w-full py-1 mt-1 overflow-auto text-base bg-white rounded-md shadow-lg max-h-60 ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
            {sortOptions.map((option, index) => (
              <Listbox.Option
                key={`sort-${index}`}
                className={`cursor-pointer select-none relative py-2 pl-4 pr-4`}
                value={option}
              >
                {({ active }) => {
                  const isSelected = selectedSort?.value == option.value;
                  return (
                    <>
                      <span
                        data-testid={`sort_option_${index}`}
                        className={`block font-base  ${isSelected || active
                          ? `${textClass} font-bold`
                          : 'text-gray7'
                          }`}
                      >
                        {option.label}
                      </span>
                    </>
                  );
                }}
              </Listbox.Option>
            ))}
          </Listbox.Options>
        </Transition>
      </div>
    </Listbox>
  );
};

export default DesktopSort;
